import styled from "styled-components"

export interface TestimonialsQuoteProps {
    font: string
}

export const StyledTestimonial = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
    border-top: 3px solid ${props => props.theme.colors.darkGrey};

    & img{
        max-width: 40%;

      @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
        padding-top: 16px;
      }
    }

    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
       flex-direction: column;
       height: auto;
    }
`
export const StyledCopy = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px 24px 0 0;
`
export const StyledQuote = styled.div<TestimonialsQuoteProps>`
    & p{
        color: ${props => props.theme.colors.darkGrey};
        margin: 0;
        ${props => props.font === "bembo" ? (`  
            font-family: ${props.theme.fonts.bembo};
            font-size: 28px;
            line-height: 32px;
        `) : (`
            font-family: ${props.theme.fonts.circularBook};
            font-size: 24px;
            line-height: 28px;
        `)}
    }
`
export const StyledSignature = styled.div`
    margin-top: 24px;

    & p{
        ${props => props.theme.mixins.body}
    }
`
export const StyledName = styled.div`
    & p{
        ${props => props.theme.mixins.bold}
    }
`
 